import React from "react";
import {
  X,
  Mail,
  Facebook,
  Instagram,
  MessageCircle,
} from "lucide-react";

import { FaPinterest } from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="relative mt-12 bg-black text-gray-300 overflow-hidden">
      {/* Soft glow (reduced) */}
      <div className="absolute inset-0">
        <div className="absolute -top-24 -left-24 w-64 h-64 bg-pink-500/15 rounded-full blur-3xl" />
        <div className="absolute top-10 -right-24 w-64 h-64 bg-purple-500/15 rounded-full blur-3xl" />
      </div>

      <div className="relative max-w-7xl mx-auto px-6 py-10">
        {/* MAIN GRID */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center md:text-left">

          {/* BRAND */}
          <div className="space-y-2">
            <h2 className="text-2xl font-extrabold tracking-widest text-white">
              DAXMA
            </h2>
            <p className="text-xs text-gray-400 max-w-xs mx-auto md:mx-0">
              Designed for comfort. Styled for you.
            </p>
          </div>

          {/* LINKS */}
          <div className="bg-white/5 backdrop-blur-sm rounded-xl p-4 border border-white/10">
            <h3 className="text-white font-semibold mb-3 text-sm">
              Explore
            </h3>
            <ul className="grid grid-cols-3 gap-2 text-xs">
              {[
                { label: "Home", path: "/" },
                { label: "Men", path: "/men" },
                { label: "Women", path: "/women" },
                { label: "Kids", path: "/kids" },
                { label: "Customize", path: "/customize" },
                { label: "Contact", path: "/contact" },
              ].map(({ label, path }) => (
                <li key={label}>
                  <a
                    href={path}
                    className="hover:text-purple-700 transition"
                  >
                    {label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* SOCIAL */}
        <div className="bg-white/5 backdrop-blur-sm rounded-xl p-4 border border-white/10">
  <h3 className="text-white font-semibold mb-3 text-sm">
    Connect
  </h3>

  <div className="flex justify-center md:justify-start gap-3">
    {[
      {
        icon: MessageCircle,
        hover: "hover:bg-green-500",
        link: "https://wa.me/919361454100", // replace with your WhatsApp number
      },
      {
        icon: Instagram,
        hover: "hover:bg-pink-500",
        link: "https://www.instagram.com/daxmaindia?igsh=NnpzOWl6dnJhZ3dx",
      },
      {
        icon: Facebook,
        hover: "hover:bg-blue-500",
        link: "https://www.facebook.com/people/Daxma-India/61586695238478/?sk=about",
      },
      {
        icon: FaPinterest, 
        hover: "hover:bg-red-600",
        link: "https://in.pinterest.com/daxmaindia/",
      },
      {
        icon: X,
        hover: "hover:bg-sky-500",
        link: "https://x.com/daxmaindia",
      },
      {
        icon: Mail,
        hover: "hover:bg-red-500",
        link: "mailto:daxmaindia@gmail.com",
      },
    ].map(({ icon: Icon, hover, link }, i) => (
      <a
        key={i}
        href={link}
        target="_blank"
        rel="noopener noreferrer"
        className={`p-2.5 rounded-lg bg-black/40 border border-white/10 
        transition hover:text-white hover:-translate-y-1 ${hover}`}
      >
        <Icon size={14} />
      </a>
    ))}
  </div>
  </div>
        </div>

        {/* BOTTOM */}
        <div className="mt-6 text-center">
          <div className="h-px bg-white/10 mb-3" />
          <p className="text-[11px] text-gray-500 tracking-wide">
            © 2025 DAXMA. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
